var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglishIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.42773,
    width: 24,
    height: 17.1429,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5915_228909",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.42773,
    width: 24,
    height: 17.1429,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5915_228909)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.42773,
    width: 24,
    height: 17.1429,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.0988 1.78516L9.14332 8.69355V2.28497H14.8576V8.69355L25.0997 1.78516L26.3779 3.6801L18.2801 9.14211H24.0005V14.8564H18.2801L26.3779 20.3184L25.0997 22.2133L14.8576 15.305V21.7135H9.14332V15.305L-1.0988 22.2134L-2.37695 20.3184L5.72081 14.8564H0.00046134V9.14211H5.72081L-2.37695 3.6801L-1.0988 1.78516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.001 8.85477L26.857 1.71289",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1543 15.1689L26.8862 21.7285",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86209 8.83733L-3.28906 1.99609",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9631 15.0889L-3.28906 22.5508",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7134H10.2857V20.5706H13.7143V13.7134H24V10.2849H13.7143V3.42773H10.2857V10.2849H0V13.7134Z",
    fill: "#E6273E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishIcon);
export default __webpack_public_path__ + "static/media/english-icon.0fd0fb656f7e9487316756848365ab5f.svg";
export { ForwardRef as ReactComponent };